import 'bootstrap/dist/js/bootstrap.bundle';
import 'icheck-bootstrap/icheck-bootstrap.min.css';
import 'admin-lte/dist/css/alt/adminlte.light.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-tabs/style/react-tabs.css';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import './styles/main.css';

import 'admin-lte';
import { Provider } from 'react-redux';
import AppRouter from './router';
import store from './redux/store';

function App() {
    return (
        <Provider store={store}>
            <AppRouter />
        </Provider>
    );
}

export default App;
